export const WALLET_ADAPTER_CORE_VERSION = "8.5.1";
